export const LIVE_FORM_Z_INDEX = {
  PREVIEW: 120,
  TOP_BAR: 130,
  SIDEBAR_OVERLAY: 140,
  SIDEBAR_NAVIGATION: 150,
};
